var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "10px",
    viewBox: "0 0 13 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-601.000000, -116.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-quote",
    transform: "translate(601.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,5.55555556 L3.10869565,5.55555556 L3.10869565,6.11111111 C3.10869565,7.18333333 2.47480435,8.05555556 1.69565217,8.05555556 L1.41304348,8.05555556 L1.41304348,10 L1.69565217,10 C3.8773913,10 5.65217391,8.25555556 5.65217391,6.11111111 L5.65217391,0 L0,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34782609,0 L7.34782609,5.55555556 L10.4565217,5.55555556 L10.4565217,6.11111111 C10.4565217,7.18333333 9.82263043,8.05555556 9.04347826,8.05555556 L8.76086957,8.05555556 L8.76086957,10 L9.04347826,10 C11.2252174,10 13,8.25555556 13,6.11111111 L13,0 L7.34782609,0 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteQuote);
export default __webpack_public_path__ + "static/media/icon-rte-quote.5bc88f00305257761a8c536c944879a6.svg";
export { ForwardRef as ReactComponent };